import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import {
  useStyles,
  ModalCancelButton,
  ModalDeleteButton
} from '../parts/cloudStorage/style/style';

import { Grid, Snackbar, Select, MenuItem } from '@material-ui/core';
import { DeleteFileType } from '../../apicalls/cloud/fileType';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

type TFprops = {
  fileTypeId: number;
  fileTypeName: string;
  fileTypeCount: number;
  fileTypes: any;
  getAllFileTypes: any;
  openDeleteFileTypeModal: boolean;
  setOpenDeleteFileTypeModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const DeleteFileTypeField: React.FC<TFprops> = (props: TFprops) => {
  const {
    fileTypeId,
    fileTypeName,
    fileTypeCount,
    openDeleteFileTypeModal,
    setOpenDeleteFileTypeModal,
    getAllFileTypes,
    fileTypes
  } = props;

  const classes = useStyles();
  // メッセージ
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [newFileTypeId, setNewFileTypeId] = useState<number | null>();

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  // 資料種別削除
  const DeleteType = () => {
    DeleteFileType(fileTypeId, newFileTypeId ? newFileTypeId : null).then(
      data => {
        if (data === 'Not logged in!') {
          <Redirect to='/' />;
        } else {
          if (typeof data === 'string') {
            setErrorMessage(data);
            setOpen(true);
          } else {
            if (data.error) {
              setErrorMessage(data.error);
              setOpen(true);
            } else setErrorMessage(data.message);
            setOpenSuccess(true);
            getAllFileTypes();
            setTimeout(() => {
              setOpenDeleteFileTypeModal(false);
            }, 2000);
          }
        }
      }
    );
  };

  return (
    <>
      {fileTypeCount == 0 ? (
        /* ----格納数が0の場合---- */
        <form className={classes.paper}>
          <Grid container>
            <Grid item xs={12} style={{ padding: 36 }}>
              <div style={{ textAlign: 'center' }}>
                <h1 style={{ marginBottom: 24, fontSize: 24 }}>
                  資料種別を削除
                </h1>
                <div className={classes.container}>
                  <div style={{ marginRight: 24 }}>
                    「{fileTypeName}」を削除しますか？
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.modalFooter}>
              <ModalCancelButton
                variant='contained'
                onClick={() => {
                  setOpenDeleteFileTypeModal(false);
                }}
              >
                キャンセル
              </ModalCancelButton>
              <ModalDeleteButton
                variant='contained'
                onClick={() => {
                  DeleteType();
                }}
              >
                削除する
              </ModalDeleteButton>
            </Grid>
          </Grid>
        </form>
      ) : (
        /*----格納ファイルがある場合---- */
        <form className={classes.paper}>
          <Grid container>
            <Grid item xs={12} style={{ padding: 36 }}>
              <div style={{ textAlign: 'center' }}>
                <h1 style={{ marginBottom: 24, fontSize: 24 }}>
                  資料種別名を削除
                </h1>
                <div className={classes.container}>
                  <div>
                    <div>
                      「{fileTypeName}」に指定されているファイルが
                      {fileTypeCount}個あります。
                    </div>
                    <div style={{ marginBottom: 24, color: 'red' }}>
                      移動先の種別を選択してください。
                    </div>
                  </div>
                </div>
                <Select
                  style={{
                    width: 250,
                    backgroundColor: '#fff',
                    margin: 'auto'
                  }}
                  onChange={(e: React.ChangeEvent<{ value: unknown }>) => {
                    setNewFileTypeId(e.target.value as number);
                  }}
                >
                  {fileTypes.map(
                    (type: any) =>
                      fileTypeId !== type.id && (
                        <MenuItem value={type.id}>{type.name}</MenuItem>
                      )
                  )}
                </Select>
              </div>
            </Grid>
            <Grid item xs={12} className={classes.modalFooter}>
              <ModalCancelButton
                variant='contained'
                onClick={() => {
                  setOpenDeleteFileTypeModal(false);
                }}
              >
                キャンセル
              </ModalCancelButton>
              <ModalDeleteButton
                variant='contained'
                onClick={() => {
                  console.log('削除');
                  DeleteType();
                }}
              >
                削除する
              </ModalDeleteButton>
            </Grid>
          </Grid>
        </form>
      )}
      {/* メッセージ表示 */}
      <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
        <Alert onClose={handleClose} severity='error'>
          {errorMessage}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccess}
        autoHideDuration={4000}
        onClose={handleCloseSuccess}
      >
        <Alert onClose={handleCloseSuccess} severity='success'>
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};
